export default "/images/vendor/intl-tel-input/build/flags.webp?ddfa4155922198c5305f1e49d52dee46";